import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import styles from './ChangeCalculatorField.module.scss'

const ChangeCalculatorField = ({ label, text, state, canClear, onClear, className, ...props }) => {
  const classNames = cn(styles.changeCalculatorField, className)

  return (
    <div {...props} className={classNames}>
      <span className={styles.label}>{label}</span>
      <div className={cn(styles.textContainer, styles[state])}>
        <span className={styles.text}>{text}</span>
        {/* {clearButton} */}
      </div>
    </div>
  )
}

ChangeCalculatorField.defaultProps = {
  label: '',
  text: '',
  state: 'default',
  canClear: false,
  onClear: () => {},
}

ChangeCalculatorField.propTypes = {
  label: PropTypes.string,
  text: PropTypes.string,
  state: PropTypes.oneOf(['default', 'active', 'prominent']),
  canClear: PropTypes.bool,
  onClear: PropTypes.func,
}

export default ChangeCalculatorField
